import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/homeview/guardians/kk.png';
import _imports_1 from '@/assets/homeview/guardians/ii.png';
import _imports_2 from '@/assets/homeview/guardians/zz.png';
import _imports_3 from '@/assets/homeview/guardians/uu.png';
import _imports_4 from '@/assets/homeview/guardians/nn.png';
import _imports_5 from '@/assets/homeview/guardians/aa.png';
const _hoisted_1 = {
  class: "guardians-section luxy-el",
  "data-speed-y": "-75"
};
const _hoisted_2 = {
  class: "panel"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "decoration left"
}), /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "GUARDIANS"), /*#__PURE__*/_createElementVNode("div", {
  class: "decoration right"
})], -1);
const _hoisted_4 = {
  class: "avatars-container-wrapper"
};
const _hoisted_5 = {
  class: "avatars-container"
};
const _hoisted_6 = {
  class: "guardian-container-wrapper"
};
const _hoisted_7 = {
  class: "guardian-container"
};
const _hoisted_8 = {
  class: "big-avatar-container"
};
const _hoisted_9 = {
  class: "big-avatar-frame"
};
const _hoisted_10 = {
  key: 0,
  class: "big-avatar",
  src: _imports_0
};
const _hoisted_11 = {
  key: 1,
  class: "big-avatar",
  src: _imports_1
};
const _hoisted_12 = {
  key: 2,
  class: "big-avatar",
  src: _imports_2
};
const _hoisted_13 = {
  key: 3,
  class: "big-avatar",
  src: _imports_3
};
const _hoisted_14 = {
  key: 4,
  class: "big-avatar",
  src: _imports_4
};
const _hoisted_15 = {
  key: 5,
  class: "big-avatar",
  src: _imports_5
};
const _hoisted_16 = {
  class: "name-container"
};
const _hoisted_17 = {
  key: 0,
  class: "name"
};
const _hoisted_18 = {
  key: 1,
  class: "name"
};
const _hoisted_19 = {
  key: 2,
  class: "name"
};
const _hoisted_20 = {
  key: 3,
  class: "name"
};
const _hoisted_21 = {
  key: 4,
  class: "name"
};
const _hoisted_22 = {
  key: 5,
  class: "name"
};
const _hoisted_23 = {
  class: "biography-container"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "top-left small-corner-decoration"
}, null, -1);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "top-right small-corner-decoration"
}, null, -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-left small-corner-decoration"
}, null, -1);
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-right small-corner-decoration"
}, null, -1);
const _hoisted_28 = {
  key: 0,
  class: "text"
};
const _hoisted_29 = {
  key: 1,
  class: "text"
};
const _hoisted_30 = {
  key: 2,
  class: "text"
};
const _hoisted_31 = {
  key: 3,
  class: "text"
};
const _hoisted_32 = {
  key: 4,
  class: "text"
};
const _hoisted_33 = {
  key: 5,
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(["avatar k", {
      active: _ctx.activeGuardian === 'k'
    }]),
    onClick: _cache[0] || (_cache[0] = () => _ctx.activeGuardian = 'k')
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["avatar i", {
      active: _ctx.activeGuardian === 'i'
    }]),
    onClick: _cache[1] || (_cache[1] = () => _ctx.activeGuardian = 'i')
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["avatar z", {
      active: _ctx.activeGuardian === 'z'
    }]),
    onClick: _cache[2] || (_cache[2] = () => _ctx.activeGuardian = 'z')
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["avatar u", {
      active: _ctx.activeGuardian === 'u'
    }]),
    onClick: _cache[3] || (_cache[3] = () => _ctx.activeGuardian = 'u')
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["avatar n", {
      active: _ctx.activeGuardian === 'n'
    }]),
    onClick: _cache[4] || (_cache[4] = () => _ctx.activeGuardian = 'n')
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["avatar a", {
      active: _ctx.activeGuardian === 'a'
    }]),
    onClick: _cache[5] || (_cache[5] = () => _ctx.activeGuardian = 'a')
  }, null, 2)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_ctx.activeGuardian === 'k' ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _ctx.activeGuardian === 'i' ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _ctx.activeGuardian === 'z' ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : _ctx.activeGuardian === 'u' ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _ctx.activeGuardian === 'n' ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _ctx.activeGuardian === 'a' ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_ctx.activeGuardian === 'k' ? (_openBlock(), _createElementBlock("p", _hoisted_17, "K.K")) : _ctx.activeGuardian === 'i' ? (_openBlock(), _createElementBlock("p", _hoisted_18, "I.I")) : _ctx.activeGuardian === 'z' ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Z.Z")) : _ctx.activeGuardian === 'u' ? (_openBlock(), _createElementBlock("p", _hoisted_20, "U.U")) : _ctx.activeGuardian === 'n' ? (_openBlock(), _createElementBlock("p", _hoisted_21, "N.N")) : _ctx.activeGuardian === 'a' ? (_openBlock(), _createElementBlock("p", _hoisted_22, "A.A")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _hoisted_25, _hoisted_26, _hoisted_27, _ctx.activeGuardian === 'k' ? (_openBlock(), _createElementBlock("p", _hoisted_28, " Kuvell Kindheart (K.K) is the battle Goddess and the Goddess of creation’s eldest daughter. She has a warm and caring personality, however she is driven by a strong sense of justice and will not back down from taking action against those who harm her loved ones. Her beauty is said to draw people of all races to her, which she finds bothersome at times. She is close with I.I and has complete faith in him as a strategist. ")) : _ctx.activeGuardian === 'i' ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Isaiah Ishrone (I.I) has the temperament of a quiet, kind, and quick-witted man. When he gets drunk, his personality changes into that of a Kamidere. I.I is the current strategist and only human on the team. His perseverance in learning magic and seeking new knowledge earned him the title of humanity's strongest mage. ")) : _ctx.activeGuardian === 'z' ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Zacharius Zenithbane (Z.Z) is Muscle-bound and physically strong as a result of years of enduring many hardships. He has a strong fighting spirit and enjoys fighting against strong opponents; as a result, rose through the ranks to become the Demon King, but he now wishes to pursue a different path. ")) : _ctx.activeGuardian === 'u' ? (_openBlock(), _createElementBlock("p", _hoisted_31, " Uriel Ukiyo (U.U) is a tall demi human/demigod, and possesses unique abilities in Mystic arts. His flames can summon an army of spirit foxes that burn anything they touch. Because of this power, he prefers to be a solitary traveller, capable of handling things on his own. Despite their differences in nature, he has a strong bond with A.A and a natural instinct to protect her. ")) : _ctx.activeGuardian === 'n' ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Nao Narumi (N.N) is the second Demon Race in Kizuna, a succubus, and Z.Z's childhood friend. As a hobby, she uses her abilities and succubus to trick people in their dreams. She is often lazy, summoning her devil bats to do the work for her. ")) : _ctx.activeGuardian === 'a' ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Aurora Ashewood (A.A) is the Spirit Fairies' queen and Goddess Haruki's closest companion. She resides in the same area as the goddess, so she has seen little of the outside world. Her radiant smile is said to heal those who come into contact with her. ")) : _createCommentVNode("", true)])])])])]);
}